import { AddPertanyaanPayload } from "../../../../models/Pertanyaan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allPertanyaanKey } from "../../queries/Pertanyaan/useFetchAllPertanyaan";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function addPertanyaan(data: AddPertanyaanPayload) {
  const res = await ApiClient.post(`/AddPertanyaan`, data);
  return res.data;
}

export const useAddPertanyaan = mutationWrapper(addPertanyaan, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allPertanyaanKey);
  },
});
